export default "__VITE_ASSET__B90b07Zl__"